module.exports = __webpack_public_path__ + "static/BT-mobile-17-2dd330e9e803eb53243a80c6904880da.jpg";